import type { PlanSourceQuantities as SourceQuantities } from "../../../shared/production/plan-source-quantities";

const number = new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 9 });
const units = { kg: "KG", koli: "KOLİ", adet: "ADET" };

export function PlanSourceQuantities({ source }: { source: SourceQuantities }) {
  const quantity = (value: number | null) => value === null ? "Belirtilmemiş"
    : `${number.format(value)} ${source.unit ? units[source.unit] : "(birim doğrulanmadı)"}`;
  return <div>
    <p><strong>Excel kaynak miktarları</strong> · {source.sheetName}, satır {source.sourceRow}</p>
    <p>Toplam: {quantity(source.orderQuantity.value)}</p>
    <p>Önceki ÜRETİM: {quantity(source.alreadyProduced.value)}</p>
    <p>KALAN: {quantity(source.remainingQuantity.value)}</p>
    <p>Kaynak satırın tamamına aittir; gün veya vardiya miktarı değildir. Excel ÜRETİM değerinin tarih kapsamı doğrulanmadı; sistem gerçekleşmesine eklenmez.</p>
  </div>;
}
